__webpack_require__.p = "/res/react-dist/";